import {
  Stethoscope,
  Scissors,
  Activity,
  Video,
  ScanLine,
  FlaskConical,
  Sparkles,
} from "lucide-react";

const MAP = {
  Stethoscope,
  Scissors,
  Activity,
  Video,
  ScanLine,
  FlaskConical,
  Sparkles,
};

export const ServiceIcon = ({ name, ...props }) => {
  const Cmp = MAP[name] || Stethoscope;
  return <Cmp {...props} />;
};
